module.exports = __webpack_public_path__ + "img/loginImg.d2895d67.png";